import { t } from "./Translate"
import { openObjectMenu } from "./ObjectMenu"

// The objects list: one row per character or prop. The thumbnail selects it
// (its name shows on hover); eye and lock toggles and a "…" button (or
// right-click) for everything else appear on hover or when selected.

const icon = (name) => `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#${name}" /></svg>`

const addRow = (subject, { thumbnail, name, onSelect, toggles }) => {
	const isTouch = "ontouchstart" in document.documentElement
	const menu = document.querySelector("#characters")

	const row = document.createElement("li")
	row.id = subject.id
	row.classList.add("object-row")
	if (subject.attachedTo) row.classList.add("is-attached")

	if (!isTouch) {
		row.onmouseenter = () => subject.hover()
		row.onmouseleave = () => subject.unhover()
	}
	row.oncontextmenu = (event) => {
		event.preventDefault()
		openObjectMenu(subject, event.clientX, event.clientY)
	}

	const select = document.createElement("button")
	select.className = "row-select"
	select.title = name
	select.setAttribute("aria-label", name)
	select.innerHTML = `${thumbnail}<span class="row-attached">${icon("link")}</span>`
	select.onclick = onSelect
	addTabTooltip(select)
	row.appendChild(select)

	toggles.forEach(({ action, title, iconOn, iconOff, isOff, toggle, stateClass }) => {
		const button = document.createElement("button")
		button.className = "row-toggle"
		// Shortcuts and menus toggle through this button, so the row stays in sync
		button.dataset.shortcut = action
		button.title = title
		const render = () => {
			row.classList.toggle(stateClass, isOff())
			button.innerHTML = icon(isOff() ? iconOff : iconOn)
		}
		render()
		button.onclick = (event) => {
			event.stopPropagation()
			toggle()
			render()
		}
		addTabTooltip(button)
		row.appendChild(button)
	})

	const more = document.createElement("button")
	more.className = "row-more"
	more.title = t("More")
	more.innerHTML = icon("more-horizontal")
	more.onclick = (event) => {
		event.stopPropagation()
		const rect = more.getBoundingClientRect()
		openObjectMenu(subject, rect.left, rect.bottom + 4)
	}
	addTabTooltip(more)
	row.appendChild(more)

	menu.appendChild(row)
}

const hideToggle = (subject) => ({
	action: "hide",
	title: t("Hide toggle (H)"),
	iconOn: "eye",
	iconOff: "eye-off",
	stateClass: "is-hidden",
	isOff: () => !subject.object.visible,
	toggle: () => subject.toggleVisibility(),
})

export const addCharacterToTabs = (character) => {
	addRow(character, {
		thumbnail: `<img src="${character.thumbnail}" alt="" />`,
		name: t(character.info.title),
		onSelect: () => character.selectCharacter(),
		toggles: [
			hideToggle(character),
			{
				action: "lock",
				title: t("Lock toggle (K)"),
				iconOn: "unlock",
				iconOff: "lock",
				stateClass: "is-locked",
				isOff: () => character.jointsHidden,
				toggle: () => character.toggleJoints(),
			},
		],
	})
}

export const addPropToTabs = (prop) => {
	addRow(prop, {
		thumbnail: prop.icon
			? `<img src="${prop.icon}" alt="" />`
			: `<span class="row-icon">${icon(prop.info.icon)}</span>`,
		name: prop.title || t(prop.info.name),
		onSelect: () => prop.onTap(),
		toggles: [
			hideToggle(prop),
			{
				action: "lock",
				title: t("Lock toggle (K)"),
				iconOn: "unlock",
				iconOff: "lock",
				stateClass: "is-locked",
				isOff: () => prop.locked,
				toggle: () => prop.toggleLock(),
			},
		],
	})
}

// Toggle hide or lock through the row, so its icon and state stay in sync
export const toggleRowState = (subject, action) => {
	const button = document.getElementById(subject.id)?.querySelector(`[data-shortcut="${action}"]`)
	if (button) button.click()
}

// The tab list clips overflow, so the tooltip lives on body with fixed
// positioning and sits to the right of the hovered row.
let tabTooltip
export const addTabTooltip = (button) => {
	if (!button.title || !window.matchMedia("(hover: hover)").matches) return
	button.addEventListener("mouseenter", () => {
		if (!tabTooltip) {
			tabTooltip = document.createElement("div")
			tabTooltip.classList.add("tooltip", "tab-tooltip")
			document.body.append(tabTooltip)
		}
		const rect = button.getBoundingClientRect()
		// Beside the whole row, so it never covers the buttons that appear on hover
		const right = (button.closest("li") || button).getBoundingClientRect().right
		tabTooltip.textContent = button.title
		tabTooltip.style.left = `${right + 8}px`
		tabTooltip.style.top = `${rect.top + rect.height / 2}px`
		tabTooltip.style.display = "block"
	})
	button.addEventListener("mouseleave", hideTabTooltip)
	button.addEventListener("click", hideTabTooltip)
}
const hideTabTooltip = () => {
	if (tabTooltip) tabTooltip.style.display = "none"
}

export const updateTab = (object, action) => {
	const element = document.getElementById(object.id)
	action(element)
}

export const clearCharacterTabs = () => {
	const menu = document.querySelector("#characters")
	menu.innerHTML = ""
}

export const removeFromTabs = (object) => {
	if (document.getElementById(object.id)) {
		document.getElementById(object.id).remove()
	}
}
